var map = {
	"./business-recommend/route": [
		61700,
		4332
	],
	"./buyers-library/route": [
		83007,
		8829
	],
	"./customer-mining/route": [
		46022,
		5884
	],
	"./customs-data/route": [
		79622,
		7246
	],
	"./dashboard/route": [
		39629,
		5865
	],
	"./error/route": [
		6807,
		7755
	],
	"./home/route": [
		74742,
		3710
	],
	"./login/route": [
		8076,
		3410
	],
	"./portal/route": [
		15415,
		409
	],
	"./print-pdf-content/route": [
		17949,
		3453
	],
	"./promotion/route": [
		56552,
		5482
	],
	"./risk-monitoring/route": [
		81389,
		5941
	],
	"./use-help/route": [
		17884,
		8524
	],
	"./user-center/route": [
		96550,
		9136
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 91928;
module.exports = webpackAsyncContext;